<template>
  <div class="page">
    <div class="rwsta" v-if="isMyworks == 1 && detail.audit_status != 1">
      <span :class="worksStatusClass">{{
        worksStatus[detail.audit_status]
      }}</span>
      <!-- <span class="shz" style="display: none; background: red;"
        >审核未通过</span
      > -->
    </div>
    <div class="detail-wrap">
      <img class="detail-bg" :src="detailBg" />
      <div class="detail-top" v-if="isMyworks != 1">
        <div class="user">
          <img class="avatar" :src="detail.avatar" />
          <div>
            <div class="username">{{ detail.nickname }}</div>
            <div class="time">{{ detail.add_time }}</div>
          </div>
        </div>
        <!-- <a class="btn btn-follow" href="javascript:" onClick="follow(this)"
          >关注</a
        > -->
      </div>
      <div class="my-matchtitle" v-if="isMyworks == 1">{{ matchTitle }}</div>
      <div class="pic-box swiper-container">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(item, index) in detail.images"
            :key="index"
          >
            <img class="pic" :src="item.image" />
          </div>
        </div>
      </div>
    </div>
    <div class="detail-title">
      <span class="label" v-if="groupType.length > 0">{{
        detail.groupname
      }}</span>
      <span class="swiper-pagination"></span>
      <span> {{ detail.mname }}</span>
    </div>
    <div class="detail-like" v-if="isShowVote">
      <span class="o">{{ detail.vote_num }}</span> 赞
    </div>
    <!--第二名rank-2，第三名rank-3-->
    <div class="myrank rank-1" style="display: none"><i></i>第一名</div>
    <div class="detail-text">{{ detail.remark }}</div>
    <div
      class="bottom"
      v-if="isShowShare || isShowVote || isShowEdit || isShowDel"
    >
      <a v-if="isShowShare" class="btn-w btn-share" href="javascript:"
        ><i></i>分享</a
      >
      <a
        v-if="isShowVote"
        class="btn-w btn-like"
        href="javascript:"
        @click="vote"
        ><i></i>点赞</a
      >
      <a v-if="isShowEdit" class="btn-w" href="javascript:" @click="edit"
        ><i></i>编辑</a
      >
      <a v-if="isShowDel" class="btn-w" href="javascript:" @click="del"
        ><i></i>删除</a
      >
    </div>
  </div>
</template>

<script>
import Swiper from "swiper/js/swiper.js";
export default {
  data() {
    return {
      workid: this.$route.params.workid,
      id: this.$route.params.id,
      isMyworks: this.$route.query.myworks,
      detail: {
        avatar: "",
        nickname: "",
        addTime: "",
        images: [],
        title: "",
        good: 0,
        rank: "",
        remark: "",
        vote_num: 0,
        last_id: 0,
      },
      groupType: [],
      detailBg: "",
      isShowFollow: false,
      isShowShare: false,
      isShowVote: false,
      isShowEdit: false,
      isShowDel: false,
      worksStatus: ["审核中", "审核通过", "审核未通过"],
      worksStatusClass: "shz",
      matchTitle: "",
    };
  },
  inject: ["reload"],
  methods: {
    getGroup() {
      this.tools.detail_cache({ id: this.id }, true).then((res) => {
        this.groupType = res.match_group;
        this.matchTitle = res.mname;
        console.log(this.groupType);
      });
    },
    initSwiper() {
      var that = this;
      var mySwiper = new Swiper(".swiper-container", {
        slidesPerView: "auto",
        centeredSlides: true,
        pagination: {
          el: ".swiper-pagination",
          type: "fraction",
        },
        lazy: {
          loadPrevNext: true,
        },
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        on: {
          // slideChangeTransitionEnd
          transitionEnd: function() {
            var idx = this.realIndex;
            // console.log(idx, that.detail.images);
            that.detailBg = that.detail.images[idx].image;
          },
          touchEnd: function() {
            var sl = mySwiper.slides.length - 1;
            var sw = mySwiper.width;
            var TR = this.translate;
            // if (TR < -(sl * sw * 0.75) && that.workid != that.detail.last_id) {
            if (TR < -(sl * sw * 0.75)) {
              // location.href = "detail.html"; //滑动到最后一张图继续向右滑动请求下一篇作品
              if (that.isMyworks == 1) {
                that.$router.push({
                  // path: "detail/" + this.id + "/myworks",
                  name: "info",
                  params: {
                    workid: that.detail.last_id,
                  },
                  query: {
                    myworks: 1,
                  },
                });
              } else {
                console.log(that.isMyworks);
                that.$router.push({
                  name: "info",
                  params: {
                    workid: that.detail.last_id,
                  },
                });
              }

              that.reload();
            }
          },
        },
      });
    },
    follow() {
      // 关注
      // this.axios
      console.log("登录后 才能关注");
    },
    // 点赞
    vote() {
      if (this.detail.has_vote == 0) {
        this.axios
          .post("/match/addVote", { id: this.workid })
          .then((res) => {
            let data = res.data;
            if (data.code == 200) {
              this.$toast.success("点赞成功");
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            }
            if (data.code == 0) {
              this.$toast.fail({
                message: data.msg,
                duration: 3500,
                className: "long-toast",
              });
            }
          })
          .catch(() => {
            /* eslint-disable */
            // 调用passport
            passportLogin.login();
            /* eslint-enable */
          });
      } else {
        this.$toast.fail({
          message: "您已经点赞过了",
          className: "long-toast",
        });
      }
    },
    edit() {
      let link = "";
      let theme = '';
      this.groupType.forEach(element => {
        if(this.detail.group == element.gid){
          theme = element.theme;
        }
      });
      // 专题赛事
      if(theme != ''){
        link = `/theme/${theme}/${this.detail.m_id}`
      }else{
        switch (this.detail.works_type) {
          case 1:
            link = "/contribute/" + this.detail.m_id + "/0/single";
            break;
          case 2:
            link = "/contribute/" + this.detail.m_id + "/0/multi";
            break;
          case 3:
            link = "/contribute/" + this.detail.m_id + "/0/group";
            break;
          case 4:
            link = "/contribute/" + this.detail.m_id + "/0/video";
            break;
          default:
            link = "/contribute/" + this.detail.m_id + "/0/single";
            break;
        }
      }
      this.$router.push({
        path: link,
        query: {
          work_id: this.workid,
          m_id: this.detail.m_id,
          group: this.detail.group,
        },
      });
    },
    del() {
      this.$dialog
        .confirm({
          title: "",
          message: "您确定要删除该投稿的所有图片吗？",
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        })
        .then(() => {
          this.axios
            .post("/match/delmyworks", { work_id: this.workid })
            .then((res) => {
              // console.log(res);
              if (res.data.code == 200 && res.data.status == "success") {
                // this.$toast.success("删除成功!");
                this.$dialog
                  .alert({
                    title: "删除成功!",
                    message: "确认后返回作品列表",
                  })
                  .then(() => {
                    // on close
                    this.$router.push({
                      // path: "detail/" + this.id + "/myworks",
                      name: "myworks",
                    });
                  });
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => {
          this.$toast.fail("已取消删除!");
        });
    },
    timestampToTime(timestamp) {
      var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      // var Y = date.getFullYear() + "-";
      var M =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      return M + "." + D;
    },
  },
  created() {
    this.getGroup();
      var data = {url:window.location.href,id:this.id};
      this.tools.wx_share_init(data);
  },
  mounted() {
    // console.log(this.$route.query);
    let params = {};
    params.id = this.workid;
    if (this.isMyworks == 1) {
      params.status = true;
    }
    this.axios.post("/match/get_work", params).then((res) => {
      // console.log(res);
      let data = res.data.data;
      Object.assign(this.detail, data);
      this.detail.add_time = this.timestampToTime(this.detail.add_time);
      this.worksStatusClass =
        this.detail.audit_status == 2 ? "shz shz-fail" : "shz";
      // console.log(this.detail);
      this.isShowVote = data.is_vote == 1;
      this.isShowDel = data.showDelete == 1 && this.isMyworks == 1;
      this.isShowEdit = data.showEdit == 1 && this.isMyworks == 1;

      this.detailBg = data.images[0].image;

      // console.log(this.detail.images);

      this.$nextTick(function() {
        this.initSwiper();
      });
    });
    // .catch(err => {
    //   console.log(err);
    // });
  },
};
</script>

<style>
@import "../../../node_modules/swiper/css/swiper.min.css";
.page {
  min-height: 100vh;
  box-sizing: border-box;
}
.shz-fail {
  background: #f00;
}
.long-toast {
  width: 40%;
  max-width: 40%;
}
</style>
